import {
  Autocomplete, Box, Button, Dialog, IconButton, Paper,
  TextField, Tooltip, Typography, Accordion, AccordionSummary, AccordionDetails
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import ShowComponents from '../../DoctorNotes/Common/ShowComponent'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import { COMMON_STYLE } from '../../../../Utility/Constants'
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const treatmentData = {
  treatmentNotes: '',
  selectedTemplate: null,
  templateList: [],
  openTemplatePopup: false,
  templateName: '',
  templateNotes: '',
  templateId: null,
  addTemplate: false,
  postTempLoad: false,
  dupTreatmentNotes: null
}

const UmaTreatmentPlan = React.forwardRef((props, ref) => {
  const [treatment, setTreatment] = useState(treatmentData)
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - TREATMENT PLAN`,
    })
    setTreatment((prev) => ({
      ...prev,
      postTempLoad: false
    }))
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - TREATMENT PLAN`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  React.useImperativeHandle(ref, () => ({
    performTreatmentPlanAction: () => {
      if (JSON.stringify(treatment.treatmentNotes) !== treatment.dupTreatmentNotes) {
        postTreatmentPlanData()
      }
    }
  }))

  const apicalls = async () => {
    await getTreatmentPlanData()
    await getTreatmentPlanTemplateData()
  }

  useEffect(() => {
    if (treatment.postTempLoad) {
      postTreatmentPlanTemplateData()
    }
  }, [treatment.postTempLoad])

  useEffect(() => {
   props.setAccordionOpen((treatment?.treatmentNotes && treatment?.treatmentNotes?.trim()) ? true : false);
  }, [treatment?.treatmentNotes])

  const getTreatmentPlanData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_TREATMENT_PLAN + '?appointment_id=' + props?.props?.appointment_id + 
        '&doctor_id=' + (props.props?.doctorID || props.props.patient_details?.doctor_id)
      )
      if (response?.data?.status === 'success') {
        let treatData = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        setTreatment((prev) => ({
          ...prev,
          treatmentNotes: Object.keys(treatData)?.length > 0 ? treatData?.comments : '',
          dupTreatmentNotes: Object.keys(treatData)?.length > 0 ? JSON.stringify(treatData?.comments) : JSON.stringify(''),
        }))
        // props.setAccordionOpen((treatData?.comments && treatData?.comments?.trim()) ? true : false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getTreatmentPlanTemplateData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_TREATMENT_PLAN_TEMPLATE + '?doctor_id=' + (props.props?.doctorID || props.props.patient_details?.doctor_id))
      if (response?.data?.status === 'success') {
        setTreatment((prev) => ({
          ...prev,
          templateList: response?.data?.data || []
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const postTreatmentPlanData = async () => {
    try {
      let data = {
        appointment_id: props?.props?.appointment_id,
        comments: treatment.treatmentNotes,
        doctor_id: props.props?.doctorID || props.props.patient_details?.doctor_id
      }
      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_TREATMENT_PLAN)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        setTreatment((prev) => ({
          ...prev,
          openTemplatePopup: false,
          templateName: '', templateId: null,
          templateNotes: '', addTemplate: false,
          selectedTemplate: null, postTempLoad: false
        }))
        await getTreatmentPlanData()
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const postTreatmentPlanTemplateData = async () => {
    try {
      let data = {
        id: treatment.templateId || null,
        template_name: treatment.templateName || '',
        comments: treatment.templateNotes,
        doctor_id: props.props?.doctorID || props.props.patient_details?.doctor_id
      }
      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_TREATMENT_PLAN_TEMPLATE)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        setTreatment((prev) => ({
          ...prev,
          openTemplatePopup: false,
          templateName: '', templateId: null,
          templateNotes: '', addTemplate: false,
          selectedTemplate: null, postTempLoad: false
        }))
        await getTreatmentPlanTemplateData()
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const renderTemplatePopup = () => {
    try {
      return (
        <Dialog open={treatment.openTemplatePopup} fullWidth maxWidth='sm'>
          <Box className='doc_addendum_popup'>
            <Box component={'div'} p={'0.2rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
              <Typography className='doc_notes_header_card_font'>{treatment.addTemplate ? 'Template' : 'Edit Template'}</Typography>
              <IconButton emed_tid='tmp_cls'
                onClick={() => setTreatment((prev) => ({
                  ...prev,
                  openTemplatePopup: false,
                  templateName: '', templateId: null, templateNotes: ''
                }))}><CloseIcon /></IconButton>
            </Box>
            <Box component={'div'} p={'0.5rem'}>
              <TextField
                size='small'
                sx={{ width: '15dvw' }}
                value={treatment.templateName}
                onChange={(e) => {
                  let value = e.target.value
                  setTreatment((prev) => ({ ...prev, templateName: value }))
                }}
                inputProps={{ maxLength: 25 }}
                label={'Enter Template Name'}
                InputProps={{ emed_tid: 'tmp_name' }}
              />
              <Box component={'div'} mt={'1rem'}>
                <TextField
                  size='small'
                  multiline
                  fullWidth
                  rows={5}
                  maxRows={5}
                  value={treatment.templateNotes}
                  onChange={(e) => {
                    let value = e.target.value
                    if (value?.length <= COMMON_STYLE.CHAR_LIMIT_DESP || value === '') {
                      setTreatment((prev) => ({ ...prev, templateNotes: value }))
                    }
                  }}
                  label={'Enter Template Comments'}
                  InputProps={{ emed_tid: 'tmp_cmts' }}
                />
              </Box>
              <Box component={'div'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} mt={'0.5rem'}>
                <Button variant='outlined' sx={{ textTransform: 'capitalize', mr: '0.5rem' }} emed_tid='tmp_canls'
                  onClick={() => setTreatment((prev) => ({
                    ...prev,
                    openTemplatePopup: false,
                    templateName: '', templateId: null, templateNotes: '', addTemplate: false
                  }))}
                >Cancel</Button>
                <Button variant='contained' sx={{ textTransform: 'capitalize' }} emed_tid='tmp_save'
                  disabled={treatment.postTempLoad}
                  onClick={() => setTreatment((prev) => ({ ...prev, postTempLoad: true }))}
                >{treatment.addTemplate ? 'Add Template' : 'Update Template'}</Button>
              </Box>
            </Box>
          </Box>
        </Dialog>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  return (
    <ShowComponents onIntersection={apicalls}>
      <Box component={'div'}>
        <Accordion expanded={props.accordionOpen}
          onChange={(_, isExpanded) => {
            props.setAccordionOpen(isExpanded, true);
          }}>
          <AccordionSummary className='doc_notes_header_card' expandIcon={<ExpandMoreIcon />}>
          <Box component={'div'} className='doc_notes_header_card' display={'flex'} justifyContent={'space-between'} alignItems={'center'} width={"100%"}>
            <Typography className='doc_notes_header_card_font'>Treatment Plan</Typography>
            <Box component={'div'} mr={'0.5rem'}>
              <Autocomplete
                clearIcon
                disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                size='small'
                sx={{ width: '15dvw' }}
                options={treatment.templateList}
                value={treatment.selectedTemplate}
                getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.template_name}
                onChange={(e, newValue) => {
                  setTreatment((prev) => ({
                    ...prev,
                    selectedTemplate: newValue,
                    treatmentNotes: newValue?.comments
                  }))
                }}
                renderInput={(params) => <TextField
                  {...params}
                  placeholder='Select Template'
                  onClick={(e) => e.stopPropagation()}
                  onMouseDown={(e) => e.stopPropagation()}
                  InputProps={{
                    ...params.InputProps, emed_tid: 'tmp_name', maxLength: 50,
                    style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                  }}
                />}
                PaperComponent={({ children }) => {
                  return (
                    <Paper component={'div'}>
                      {children}
                      <Button
                        color="primary"
                        fullWidth
                        sx={{ justifyContent: "flex-start", pl: 2, textTransform: 'capitalize' }}
                        onMouseDown={(e) => {
                          setTreatment((prev) => ({
                            ...prev,
                            openTemplatePopup: true,
                            templateName: '',
                            templateNotes: '',
                            addTemplate: true
                          }))
                        }}
                        emed_tid='add_tmp'
                      >
                        Add Template
                      </Button>
                      {treatment.selectedTemplate ?
                        <Button
                          color="primary"
                          fullWidth
                          sx={{ justifyContent: "flex-start", pl: 2, textTransform: 'capitalize' }}
                          onMouseDown={(e) => {
                            setTreatment((prev) => ({
                              ...prev,
                              openTemplatePopup: true,
                              templateName: treatment.selectedTemplate?.template_name,
                              templateNotes: treatment.selectedTemplate?.comments,
                              templateId: treatment.selectedTemplate?.id,
                              addTemplate: false
                            }))
                          }}
                          emed_tid='tmp_update'
                        >
                          update
                        </Button> : null}
                    </Paper>
                  )
                }}
                renderOption={(props, option) => (
                  <li {...props} key={option?.id}>
                    {option?.template_name?.length > 20 ?
                      <Tooltip placement='top' title={option?.template_name}><Typography fontSize={'0.9rem'}>{option?.template_name?.slice(0, 20) + '...'}</Typography></Tooltip> :
                      <Typography fontSize={'0.9rem'}>{option?.template_name}</Typography>}
                  </li>
                )}
              />
            </Box>
          </Box>
          </AccordionSummary>
          <AccordionDetails component={'div'} m={'0.5rem'}>
            <TextField
              disabled={props?.props?.patient_transfered || props?.props?.isLocked}
              size='small'
              multiline
              fullWidth
              rows={8}
              maxRows={8}
              value={treatment.treatmentNotes}
              onChange={(e) => {
                let value = e.target.value
                if (value?.length <= COMMON_STYLE.CHAR_LIMIT_DESP || value === '') {
                  setTreatment((prev) => ({ ...prev, treatmentNotes: value }))
                }
              }}
              placeholder='Comments'
              InputProps={{ emed_tid: 'trt_notes' }}
            />
          </AccordionDetails>
        </Accordion>
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
        {renderTemplatePopup()}
      </Box>
    </ShowComponents>
  )
})

export default UmaTreatmentPlan